import React from 'react';
import {IRmaError} from '../../rma-types';
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import "./timeline-classified-error.scss";



interface ClassifiedErrorTimelineProps {
    returnError: IRmaError;
}

const TimelineClassifiedError: React.FC<ClassifiedErrorTimelineProps> = ({ returnError }) => {
    return (
        <div>
            <div>
                <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>{returnError.short_error}</FontBody1>
            </div>
            <div className='timeline-classified-error'>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>Issue(s) encountered</FontBody2>
                <ul>
                    {returnError.classified_errors?.map((error) => (
                        <li key={error.id}>
                            {error.message} ({error.code})
                        </li>
                    ))}
                </ul>
            </div>
            <div className='timeline-classified-error'>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>Recommended action(s)</FontBody2>
                <ul>
                    {returnError.classified_errors?.map((error) => (
                        <li key={error.id}>{error.recommended_action}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TimelineClassifiedError;
